export const useZigZag = () => {
  const config = useRuntimeConfig()
  const version = async (url) => {
    return await useFetch(`${url}/version.json`)
  }

  return {
    version
  }
}